import SideMenu from "components/SideMenu";
import SectionHeading from "components/text/SectionHeading";
import { useAuth } from "providers/auth.provider";
import { useSite } from "providers/site.provider";
import { useEffect, useState } from "react";
import { sendMail } from "services/apf-api.service";

export const FeedbackPage = () => {
  const { selectedSite, clearSite } = useSite();
  const { idToken } = useAuth();

  const [siteId, setSiteId] = useState(selectedSite?.id) || undefined;

  const [formData, setFormData] = useState({
    type: "feedback",
    title: "",
    description: "",
  });

  useEffect(() => {
    setSiteId(selectedSite?.id);
  }, [selectedSite]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitted Feedback:", formData);
    alert("Thank you for your submission!");
    setFormData({ type: "feedback", title: "", description: "" });

    try {
      if (siteId) {
        const subject = `FEEDBACK FORM - ${formData.type} - ${siteId}`;
        const html = `<span><strong>${formData.title}</strong><br /><p>${formData.description}</p></span>`;
        const response = await sendMail(subject, html, idToken);

        if (!response) {
          throw new Error("Failed to send email");
        }

        const data = response;
        console.log("Email sent successfully:", data);
        return data;
      }
    } catch (err) {
      console.error("Error sending email:", err);
      throw err;
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
      <SideMenu />
      <main className="p-6">
        <div className="mb-6">
          <SectionHeading
            title="Feedback"
            subtitle="Provide feedback, raise feature requests and indefify bugs"
          />

          <form onSubmit={handleSubmit} className="space-y-4 md:w-1/3">
            <div>
              <label className="block text-gray-700 font-semibold mb-1">
                Type
              </label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="feedback">Feedback</option>
                <option value="feature">Feature / Integration Request</option>
                <option value="bug">Bug Report</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">
                Title
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Short summary"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">
                Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Provide more details..."
                className="w-full border border-gray-300 rounded px-3 py-2 h-32 resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-500 text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition"
            >
              Submit
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};
